import { Text, View } from '@react-pdf/renderer';
import { PdfGeneratorStyles as styles } from '../PdfGenerator/Stylesheet.jsx';
import { ProblemData } from '../Constants.ts';
import AdditionWordProblemJson from '../../Files/WordProblems/Addition.json';
import SubtractionWordProblemJson from '../../Files/WordProblems/Subtraction.json';
import MultiplicationWordProblemJson from '../../Files/WordProblems/Multiplication.json';
import DivisionSimpleWordProblemJson from '../../Files/WordProblems/Division/Simple.json';
import NamesJson from '../../Files/Names.json';

export function GenerateWordProblem(problemData: ProblemData, problemCount: number,
   halfPage = false, answerPage = false, longDivision = false, remainders = false) {
  const fontSize = styles.font15;
  const containerHeight = halfPage ? styles.height160 : styles.height180;  

  const var1 = "{variable1}";
  const var2 = "{variable2}";
  const answer = "{answer}";
  const namePlaceholder = "{name}";
  const randomNameNumber = Math.floor(Math.random() * 50);
  const name = NamesJson.names[randomNameNumber];

  const randomStoryNumber = Math.floor(Math.random() * 50);
  let storyProblem = AdditionWordProblemJson[randomStoryNumber];
  
  switch(problemData.operator){
    case "-":{
        storyProblem = SubtractionWordProblemJson[randomStoryNumber];
        break;
    }
    case "x":{
        storyProblem = MultiplicationWordProblemJson[randomStoryNumber];
        break;
    }
    case "÷":{
        if (longDivision) {
            if (remainders){
                storyProblem = DivisionSimpleWordProblemJson[randomStoryNumber];
            }
            storyProblem = DivisionSimpleWordProblemJson[randomStoryNumber];
        } 
        else {
            storyProblem = DivisionSimpleWordProblemJson[randomStoryNumber];
        }        
        break;
    }    
  }
  
  storyProblem.story = storyProblem.story
    .replaceAll(var1, problemData.numbers[0].toString())
    .replaceAll(var2, problemData.numbers[1].toString())
    .replaceAll(namePlaceholder, name);

  storyProblem.question = storyProblem.question
    .replaceAll(namePlaceholder, name);

  storyProblem.problem = storyProblem.problem
    .replaceAll(var1, problemData.numbers[0].toString())
    .replaceAll(var2, problemData.numbers[1].toString())
    .replaceAll(answer, problemData.numbers[2].toString());

  return(
    <View key={problemData.key} style={{...styles.wordProblemContainer, ...containerHeight}}>
      <Text style={{...styles.word, ...fontSize}}>{storyProblem.story}</Text>
      {/* <Text style={{...styles.word, ...fontSize}}>{ '\n' }</Text> */}
      <Text style={{...styles.word, ...fontSize}}>{storyProblem.question}</Text>
      <Text style={{...styles.word, ...fontSize}}>{answerPage === true ? storyProblem.problem : ""}</Text>
    </View>
  );
}